import styled from '@emotion/styled'
import CheckIcon from '@material-ui/icons/Check'
import EyeIcon from '@material-ui/icons/VisibilityRounded'
import ErrorIcon from '@material-ui/icons/Error'
import stoneImage from '../assets/SignInStoneBackground.jpeg'

type InputProps = {
  fieldError: boolean
  label?: string
}

type PWInputProps = {
  fieldError: boolean
  passwordError: boolean
  label: string
}

type LinkProps = {
  fieldError: boolean
  passwordError: boolean
}

export const EmailInput = styled.input<InputProps>`
  color: #3e3f42;
  border: #e2e5ed solid 1px;
  border-radius: 4px;
  width: 87%;
  height: 18px;
  padding: 10px 15px;
  &:focus {
    border: ${props => (props.fieldError ? '#F0535D 1px solid' : '#289C91 1px solid')};
    border-radius: 4px;
    outline: none;
  }
`

export const PWInput = styled.input<PWInputProps>`
  color: #3e3f42;
  border: #e2e5ed solid 1px;
  border-radius: 4px;
  width: 87%;
  height: 18px;
  padding: 10px 15px;
  &:focus {
    border: ${props =>
      props.passwordError || props.fieldError ? '#F0535D 1px solid' : '#289C91 1px solid'};
    border-radius: 4px;
    outline: none;
  }
`
export const NewPWInput = styled.input<InputProps>`
  color: #3e3f42;
  border: #e2e5ed solid 1px;
  border-radius: 4px;
  width: 87%;
  height: 18px;
  padding: 10px 15px;
  margin-bottom: 16px;
  &:focus {
    border: ${props => (props.fieldError ? '#F0535D 1px solid' : '#289C91 1px solid')};
    border-radius: 4px;
    outline: none;
  }
`

export const PreNextButton = styled.button`
  color: #3e3f42;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #f6f7f9 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
`

export const PostNextButton = styled.button`
  color: #ffffff;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  cursor: pointer;
`

export const PreSignButton = styled.button`
  color: #3e3f42;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #f6f7f9 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
`

export const PostSignButton = styled.button`
  color: #ffffff;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  cursor: pointer;
`
export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 415px) {
    background-image: url(${stoneImage});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
`

export const LoginContainer = styled.div`
  width: 83%;
  height: 75%;
  border-radius: 4px;
  background: rgba(255, 255, 255, 95%) no-repeat padding-box;
  padding: 40px 30px;

  @media (min-width: 415px) {
    width: 315px;
    height: 580px;
  }
`

export const FormContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const LogoAndHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 120px;
  margin-bottom: 10%;
`
export const LoginNextStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%;

  @media (min-width: 415px) {
    height: 75%;
  }
`
export const FormErrorMessage = styled.div`
  position: absolute;
  color: #e6492d;
  font-size: 0.75rem;
  width: 81%;
  background-color: #fce4e5;
  border-radius: 4px;
  height: 14px;
  padding: 7px 25px;
  margin-top: 6px;
  bottom: 0;
`
export const ErrorMark = styled(ErrorIcon)`
  color: #f0535d;
  height: 14px !important;
  width: 14px !important;
  position: absolute;
  left: 5px;
`
export const FormHeader = styled.h2`
  font-size: 26px;
  color: #3e3f42;
  font-weight: 500;
  margin-bottom: 14px;

  @media (min-width: 415px) {
    font-size: 24px;
  }
`
export const FormMessage = styled.p`
  font-size: 12px;
  color: #6b6c70;
  margin: 0;

  @media (min-width: 415px) {
    font-size: 14px;
  }
`
export const PreLinkButton = styled.button`
  color: #3e3f42;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #f6f7f9 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
`

export const PostLinkButton = styled.button`
  color: #ffffff;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  cursor: pointer;
`
export const OkButton = styled.button`
  color: #ffffff;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  cursor: pointer;
`
export const ForgotPWLogoAndHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 180px;
  margin-bottom: 40px;
`
export const CheckBox = styled.div`
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  border-radius: 4px;
  height: 44px;
  width: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PrePasswordButton = styled.button`
  color: #3e3f42;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #f6f7f9 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  margin-top: 20px;
`

export const PostPasswordButton = styled.button`
  color: #ffffff;
  width: 99%;
  height: 40px;
  background: transparent linear-gradient(180deg, #38b249 0%, #34aa44 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  margin-top: 20px;
  cursor: pointer;
`
export const NewPassForm = styled.form`
  width: 84%;
  height: 80%;
  padding: 10% 8%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  background: rgba(255, 255, 255, 95%) no-repeat padding-box;
  position: relative;
  @media (min-width: 415px) {
    width: 315px;
    height: 580px;
    padding: 40px 30px;
  }
`

export const NewPWLogoAndHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 8px;
`
export const NewPWInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 220px;
`
export const PrePWCheck = styled.div`
  border: 1px solid #9ea0a5;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  margin-bottom: -4px;
`
export const PostPWCheck = styled.div`
  border: 1px solid #289c91;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  margin-bottom: -4px;
`
export const InputContainer = styled.div`
  position: relative;
  height: 95px;
`
export const ForgotPWLink = styled.p<LinkProps>`
  color: #289c91;
  font-size: 14px;
  margin-top: ${props => (props.fieldError || props.passwordError ? '40px' : '0')};
`
export const FormLabel = styled.p<{ error?: boolean }>`
  color: #9ea0a5;
  font-size: 12px;
  height: ${({ error }) => (error ? '100px' : '60px')};
`

export const NewPassHeader = styled.p`
  color: #3e3f42;
  padding-top: 50px;
  @media (min-width: 350px) {
    padding-top: 0;
  }
`
export const PrePassHeader = styled.p`
  color: #9ea0a5;
  padding-top: 50px;
  @media (min-width: 350px) {
    padding-top: 0;
  }
`
export const CommonDiv = styled.div`
  height: 100%;
`

export const PassMessageDiv = styled.div`
  margin-top: 40px;
`

export const Check = styled(CheckIcon)`
  color: #ffffff;
`
export const PasswordCheck = styled(CheckIcon)`
  color: #289c91;
  height: 12px !important;
  width: 12px !important;
`
export const PwCheckContainer = styled.div`
  display: inline-block;
  height: 16px;
`
export const PassEye = styled(EyeIcon)`
  position: absolute;
  left: 84%;
  top: 32%;
`
export const PassEyeVis = styled(EyeIcon)`
  color: #289c91;
  position: absolute;
  left: 84%;
  top: 32%;
`
export const NewPassEye = styled(EyeIcon)`
  position: absolute;
  left: 84%;
  top: 32%;
`
export const NewPassEyeVis = styled(EyeIcon)`
  color: #289c91;
  position: absolute;
  left: 84%;
  top: 32%;
`

export const PageLogo = styled.img`
  width: 48px;
  height: 48px;
`
export const ForgotPWForm = styled.form`
  height: 100%;
`
export const ReturnLoginLink = styled.p`
  color: #289c91;
  font-size: 14px;
`
export const PageForm = styled.form`
  height: 90%;

  @media (min-width: 415px) {
    height: 100%;
  }
`

export const SignInByOtherText = styled.p`
  font-size: 14px;
  color: #289c91;
  :hover {
    cursor: pointer;
  }
`
